import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    param: String,
    method: { type: String, default: "patch" },
    successMessage: { type: String, default: "Gespeichert" },
    errorMessage: { type: String, default: "Fehler beim Speichern" }
  }

  connect() {
    this.originalValue = this.element.value
  }

  change() {
    const newValue = this.element.value
    if (newValue === this.originalValue) return

    this.originalValue = newValue
    this.sendUpdate(newValue)
  }

  async sendUpdate(value) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const headers = {
      'Accept': 'text/vnd.turbo-stream.html',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken
    }

    const body = `${encodeURIComponent(this.paramValue)}=${encodeURIComponent(value)}`

    try {
      const response = await fetch(this.urlValue, {
        method: this.methodValue.toUpperCase(),
        headers,
        body
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        toastr.info(this.successMessageValue)
      } else {
        toastr.warning(this.errorMessageValue)
      }
    } catch (error) {
      console.error('Inline update failed:', error)
      toastr.warning(this.errorMessageValue)
    }
  }
}
